import React from "react"
import "./style.scss"
import { FaMapMarkerAlt } from "react-icons/fa"
import { MdCall, MdMail } from "react-icons/md"
import { TiSocialSkype } from "react-icons/ti"
import Form from "react-bootstrap/Form"
import Button from "../elements/button/Button"
import { Link } from "gatsby"
import PhoneInput from "../../components/elements/phoneInput/Input"
import Spinner from "react-bootstrap/Spinner"
import { validateEmail } from "../../utils"

const ContactUs = ({
  handleNumberSelect,
  getCountryCode,
  details,
  onChange,
  submit,
  onCheck,
}) => {
  const sectionData = {
    title: "Connect with our\nExpert to Discuss\nYour Challenges",
    countryAddress: "Wersel Workdesk",
    address: "Level39, One Canada Square,\nCanary Wharf, London E14 5AB",
    // countryAddressTwo: "India - Delhi",
    // addressTwo:
    //   "B1/638 A, 2nd Floor,\nJanakpuri, New Delhi,\nDelhi 110058, India",
    firstLine: "+44 7887 3080 38\n",
    // secondLine: "+1-380-888-3080 (US)\n",
    email: "hello@wersel.io",
    // skype: "Wersel Workdesk",
  }
  const {
    title,
    countryAddress,
    address,
    firstLine,
    secondLine,
    email,
    skype,
    countryAddressTwo,
    addressTwo,
  } = sectionData
  return (
    <div className="contact_us">
      <div className="info">
        <h1 className="title">{title}</h1>
        <div className="contact_item">
          <FaMapMarkerAlt size="35" className="mb-4" color="#F83333" />
          <h1 className="title">{countryAddress}</h1>
          <p className="text">{address}</p>
        </div>
        {/* <div className="contact_item">
          <FaMapMarkerAlt size="35" className="mb-4" color="#F83333" />
          <h1 className="title">{countryAddressTwo}</h1>
          <p className="text">{addressTwo}</p>
        </div> */}
        <div className="contact_item">
          <MdCall size="35" className="mb-4" color="#000000" />
          <p className="text">{firstLine}</p>
          {/* <p className="text">{secondLine}</p> */}
        </div>
        <div className="contact_item">
          <MdMail size="35" className="mb-4" color="#000000" />
          <p className="text">{email}</p>
        </div>
        {/* <div className="contact_item">
          <TiSocialSkype size="35" className="mb-4" color="#000000" />
          <p className="text">{skype}</p>
        </div> */}
      </div>
      <div className="contact-form">
        <div className="title-container">
          <h1 className="title">Tell us a bit about yourself</h1>
        </div>
        <div className="forms">
          <FormItem
            name="name"
            value={details.name}
            onChange={onChange}
            label="Name"
            type="text"
            error={
              details.submitted && details.name === "" && "Name cannot be empty"
            }
          />
          <FormItem
            name="company"
            value={details.company}
            onChange={onChange}
            label="Company name"
            type="text"
            error={
              details.submitted &&
              details.company === "" &&
              "Company cannot be empty"
            }
          />
          <FormItem
            name="designation"
            value={details.designation}
            onChange={onChange}
            label="Designation"
            type="text"
            error={
              details.submitted &&
              details.designation === "" &&
              "Designation cannot be empty"
            }
          />
          <FormItem
            name="email"
            value={details.email}
            onChange={onChange}
            label="Email"
            type="email"
            required
            error={
              (details.submitted &&
                details.email === "" &&
                "Email cannot be empty") ||
              (details.submitted &&
                !validateEmail(details.email) &&
                "Email not valid")
            }
          />
          <FormItem
            label="Phone"
            type="tel"
            phone
            onChange={handleNumberSelect}
            getCountryCode={getCountryCode}
            value={details.phone}
            error={
              details.submitted &&
              details.phone === "" &&
              "Phone cannot be empty"
            }
          />
          <FormItem
            name="comments"
            value={details.comments}
            onChange={onChange}
            label="Comments"
            type="text"
            error={
              details.submitted &&
              details.comments === "" &&
              "Cooments cannot be empty"
            }
          />
        </div>

        <div className="bottom-area">
          <div>
            <Form.Check>
              <Form.Check.Input
                onChange={onCheck}
                name="terms"
                checked={details.terms}
                type="checkbox"
              />
              <Form.Check.Label>
                Yes, send me emails on data-driven case studies, eBooks, blogs,
                newsletters, webinars and press releases. You can view our
                <Link to="/privacy-policy"> privacy policy </Link> here
              </Form.Check.Label>
            </Form.Check>
          </div>
          <div className="mt-3 mb-3">
            <Button onClick={submit}>
              Submit &nbsp;
              {details.requesting && <Spinner animation="border" size="sm" />}
            </Button>
          </div>
        </div>
      </div>
      <h1 className="mobile-title">{title}</h1>
    </div>
  )
}

export default ContactUs

const FormItem = ({ label, type, phone, getCountryCode, error, ...props }) => {
  return (
    <div className={`form-item ${error ? " has-error" : ""}`}>
      {!phone && (
        <div>
          <input
            onChange={props.onChange}
            name={props.name}
            value={props.value}
            type={type}
            className="inputText"
            required={props.required}
          />
          {error && <p className={"error-message"}>{error}</p>}
        </div>
      )}
      {phone && (
        <div className="mt-3 phone_input">
          <PhoneInput
            onChange={props.onChange}
            getCountryCode={getCountryCode}
            value={props.value}
          />
          {error && <p className={"error-message phone"}>{error}</p>}
        </div>
      )}
      <span className="floating-label">{label}</span>
    </div>
  )
}
